import firebase from '../../firebase/compat'

// AI-CONTEXT: See docs/features/role-based-permissions.md (v4 — server-side)
//
// Rollen toekennen, rolrechten wijzigen en uitnodigen lopen sinds 2026-11-03
// via Cloud Functions (functions/team/teamRoles.js); de Firestore-regels laten
// de browser die velden niet meer schrijven. De functies geven een status
// terug in plaats van een fout, zodat het scherm kan zeggen wat er misging.

const MELDINGEN = {
    forbidden: 'Je hebt hier geen recht toe. Je kunt ook geen rol geven met meer rechten dan je eigen rol.',
    'not-member': 'Deze persoon is geen lid van deze omgeving.',
    'unknown-role': 'Deze rol bestaat niet (meer). Ververs de pagina en kies opnieuw.',
    'not-found': 'Dit bestaat niet meer. Ververs de pagina.',
    'invalid-email': 'Vul een geldig e-mailadres in.',
    'invalid-permissions': 'Een van de rechten is onbekend. Ververs de pagina en probeer het opnieuw.',
}

/**
 * De melding bij een status die geen 'success' is.
 *
 * @param {string} status
 * @returns {string}
 */
export const teamStatusMessage = (status) =>
    MELDINGEN[status] || 'Er is iets mis gegaan, neem contact op met Deccos via info@deccos.nl.'

/**
 * Roept een team-callable aan en meldt zelf wat er misging.
 *
 * @param {'setMemberRole' | 'saveInvitation' | 'setInvitationRole' | 'manageUserRole'} name
 * @param {object} payload - Altijd met `client`
 * @returns {Promise<boolean>} true als de server 'success' antwoordde
 */
const callTeamFunction = async (name, payload) => {
    try {
        const call = firebase.app().functions('europe-west1').httpsCallable(name)
        const result = await call(payload)
        if (result.data === 'success') return true
        alert(teamStatusMessage(result.data))
        return false
    } catch (err) {
        console.error(`${name} error:`, err)
        alert(`Opslaan is mislukt: ${err.message || 'onbekende fout'}. Neem contact op met Deccos via info@deccos.nl.`)
        return false
    }
}

export default callTeamFunction
